import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { NumberText } from '../NumberText/NumberText';
import { ValueOrDash } from '../ValueOrDash/ValueOrDash';

type Props = {
    num?: number;
    fractionalPartLength?: number;
};

export class NumberCell extends React.PureComponent<Props> {
    render() {
        const { num, fractionalPartLength } = this.props;

        return (
            <div className={Bem.cls('number-cell')}>
                <ValueOrDash value={num}>
                    <NumberText num={num} fractionalPartLength={fractionalPartLength} />
                </ValueOrDash>
            </div>
        );
    }
}
